import { Dialog } from "@mui/material";
import { useCallback, useState } from "react";
import type { Dashboard } from "../../../../api/types/dashboardsTypes";
import { CopyToDialogCopying } from "./CopyToDialogCopying";
import { CopyToDialogSelection } from "./CopyToDialogSelection";
import useDashboardValidation from "./hooks/useDashboardValidation";

export interface Props {
  dashboards: Dashboard[];
  onClose: (success?: boolean) => void;
}

export default function CopyToDialog({ dashboards, onClose }: Props) {
  const dashboardValidation = useDashboardValidation(dashboards);
  const [showSecondScreen, setShowSecondScreen] = useState(false);
  const [copyConditionValues, setCopyConditionValues] = useState(true);

  const handleStartCopy = useCallback(() => {
    setShowSecondScreen(true);
  }, []);

  return (
    <>
      <Dialog open fullWidth slotProps={{ paper: { sx: { height: "800px", maxWidth: "970px" } } }}>
        {!showSecondScreen && (
          <CopyToDialogSelection
            dashboards={dashboards}
            dashboardValidation={dashboardValidation}
            copyConditionValues={copyConditionValues}
            onCopy={handleStartCopy}
            onClose={onClose}
            onCopyConditionValues={setCopyConditionValues}
          />
        )}
        {showSecondScreen && (
          <CopyToDialogCopying
            dashboards={dashboards}
            selectedCompanies={dashboardValidation.selectedCompanies}
            copyConditionValues={copyConditionValues}
            onClose={onClose}
          />
        )}
      </Dialog>
    </>
  );
}
